const PAYMENT_TYPES = {
    CARD: 'card'
};

export {
    PAYMENT_TYPES
}
